import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../header';
import Footer from '../../footer';
import { IoIceCreamOutline, IoClose, IoSearchOutline, IoSparklesOutline, IoCheckmarkCircle } from "react-icons/io5";
import { HiOutlineShoppingBag, HiOutlineClock, HiOutlineShieldCheck, HiOutlineTruck, HiPlus, HiMinus, HiTrash } from "react-icons/hi";

const products = [
    { 
        id: 1, 
        name: "Classic Malai Kulfi", 
        description: "The original rich and creamy traditional favorite made with slow-simmered pure buffalo milk and freshly crushed cardamom.", 
        category: "Classic", 
        tag: "Bestseller",
        badgeColor: "bg-amber-100 text-amber-900 border-amber-200", 
        image: "/images/products/kulfi_malai.jpg", 
        price: 50,
        highlight: "100% Pure Milk"
    },
    { 
        id: 2, 
        name: "Royal Pista Kulfi", 
        description: "Loaded with handpicked Iranian pistachios and roasted almond silvers for a rich, decadent nutty crunch.", 
        category: "Premium", 
        tag: "Customer Favorite",
        badgeColor: "bg-emerald-100 text-emerald-900 border-emerald-200", 
        image: "/images/products/kulfi_pista.jpg", 
        price: 60,
        highlight: "Real Iranian Pista"
    },
    { 
        id: 3, 
        name: "Kesar Badam Kulfi", 
        description: "Infused with genuine Kashmiri saffron strands, sweetened rabdi, and finely diced California almonds.", 
        category: "Premium", 
        tag: "Royal Treat",
        badgeColor: "bg-yellow-100 text-yellow-900 border-yellow-200", 
        image: "/images/products/kulfi_kesar.jpg", 
        price: 70,
        highlight: "Kashmiri Saffron"
    },
    { 
        id: 4, 
        name: "Alphonso Mango Kulfi", 
        description: "Crafted with 100% real Ratnagiri Alphonso mango pulp, delivering an irresistible sweet and tangy tropical delight.", 
        category: "Fruit", 
        tag: "Seasonal Favorite",
        badgeColor: "bg-orange-100 text-orange-900 border-orange-200", 
        image: "/images/products/kulfi_mango.jpg", 
        price: 60,
        highlight: "Real Mango Pulp"
    },
    { 
        id: 5, 
        name: "Rose (Gulkand) Kulfi", 
        description: "A fragrant, cooling heritage recipe prepared with organic damask rose petals and authentic sweet gulkand.", 
        category: "Floral", 
        tag: "Authentic",
        badgeColor: "bg-pink-100 text-pink-900 border-pink-200", 
        image: "/images/products/kulfi_rose.jpg", 
        price: 60,
        highlight: "Damask Rose & Gulkand"
    },
    { 
        id: 6, 
        name: "Double Chocolate Kulfi", 
        description: "Rich dark cocoa blended into thick caramelized milk with gooey Belgian chocolate chips throughout.", 
        category: "Indulgent", 
        tag: "Kids Choice",
        badgeColor: "bg-stone-200 text-stone-900 border-stone-300", 
        image: "/images/products/kulfi_chocolate.jpg", 
        price: 65,
        highlight: "Belgian Cocoa"
    },
    { 
        id: 7, 
        name: "Nawabi Paan Kulfi", 
        description: "A refreshing, aromatic Banarasi betel leaf blend with sweetened saunf and traditional after-dinner spices.", 
        category: "Classic", 
        tag: "Digestive Special",
        badgeColor: "bg-green-100 text-green-900 border-green-200", 
        image: "/images/products/kulfi_paan.jpg", 
        price: 55,
        highlight: "Real Banarasi Paan"
    },
    { 
        id: 8, 
        name: "Sitaphal Kulfi", 
        description: "Packed with real, velvety custard apple fruit pulp and chunks folded into pure reduced milk cream.", 
        category: "Fruit", 
        tag: "Exotic Fruit",
        badgeColor: "bg-lime-100 text-lime-900 border-lime-200", 
        image: "/images/products/kulfi_pista.jpg", 
        price: 65,
        highlight: "Fresh Custard Apple"
    },
    { 
        id: 9, 
        name: "Tender Coconut Kulfi", 
        description: "A refreshing coastal specialty prepared with sweet coconut water and tender coconut malai shreds.", 
        category: "Fruit", 
        tag: "Super Refreshing",
        badgeColor: "bg-slate-200 text-slate-900 border-slate-300", 
        image: "/images/products/kulfi_malai.jpg", 
        price: 60,
        highlight: "Fresh Coconut Chunks"
    },
    { 
        id: 10, 
        name: "Fresh Strawberry Kulfi", 
        description: "Sweet, tangy Mahabaleshwar strawberries blended smoothly into frozen rich creamy rabdi.", 
        category: "Fruit", 
        tag: "Berry Blast",
        badgeColor: "bg-rose-100 text-rose-900 border-rose-200", 
        image: "/images/products/kulfi_rose.jpg", 
        price: 60,
        highlight: "Mahabaleshwar Berries"
    },
    { 
        id: 11, 
        name: "Tutti Frutti Kulfi", 
        description: "A fun, vibrant carnival classic loaded with colorful candied papaya fruit bits and sweet vanilla notes.", 
        category: "Classic", 
        tag: "Nostalgic",
        badgeColor: "bg-purple-100 text-purple-900 border-purple-200", 
        image: "/images/products/kulfi_kesar.jpg", 
        price: 50,
        highlight: "Candied Fruit Bits"
    },
    { 
        id: 12, 
        name: "Anjeer & Honey Kulfi", 
        description: "Naturally sweetened with wild forest honey and filled with premium Turkish dried fig crunchy bits.", 
        category: "Premium", 
        tag: "Natural Sweetness",
        badgeColor: "bg-amber-100 text-amber-900 border-amber-300", 
        image: "/images/products/kulfi_chocolate.jpg", 
        price: 75,
        highlight: "Wild Honey & Figs"
    },
    { 
        id: 13, 
        name: "Coffee Walnut Kulfi", 
        description: "Deep roasted South Indian filter coffee decoction paired with buttery toasted walnut pieces.", 
        category: "Indulgent", 
        tag: "Artisanal",
        badgeColor: "bg-stone-200 text-stone-900 border-stone-300", 
        image: "/images/products/kulfi_chocolate.jpg", 
        price: 70,
        highlight: "Roasted Filter Coffee"
    },
    { 
        id: 14, 
        name: "Blackcurrant Kulfi", 
        description: "A sharp, tangy, sweet-and-sour wild blackcurrant explosion crafted with imported European berries.", 
        category: "Fruit", 
        tag: "Zesty Berry",
        badgeColor: "bg-fuchsia-100 text-fuchsia-900 border-fuchsia-200", 
        image: "/images/products/kulfi_rose.jpg", 
        price: 60,
        highlight: "Wild Blackcurrants"
    },
    { 
        id: 15, 
        name: "Sugar-Free Malai Kulfi", 
        description: "All the rich, velvety cardamom creaminess of traditional malai kulfi, crafted with 0g added sugar.", 
        category: "Classic", 
        tag: "Guilt-Free",
        badgeColor: "bg-teal-100 text-teal-900 border-teal-200", 
        image: "/images/products/kulfi_malai.jpg", 
        price: 65,
        highlight: "0g Added Sugar"
    },
    { 
        id: 16, 
        name: "Matka Rabdi Kulfi", 
        description: "Authentic earthen clay-pot reduced milk kulfi infused with saffron, cardamom, and caramelized thick rabdi layers.", 
        category: "Classic", 
        tag: "Heritage Special",
        badgeColor: "bg-amber-100 text-amber-900 border-amber-200", 
        image: "/images/products/kulfi_malai.jpg", 
        price: 70,
        highlight: "Clay Pot Simmered"
    },
    { 
        id: 17, 
        name: "Gulab Jamun Stuffed Kulfi", 
        description: "A decadent fusion featuring a warm, syrupy gulab jamun core wrapped inside chilled saffron rabdi kulfi.", 
        category: "Indulgent", 
        tag: "Chef's Signature",
        badgeColor: "bg-rose-100 text-rose-900 border-rose-200", 
        image: "/images/products/kulfi_kesar.jpg", 
        price: 80,
        highlight: "Gulab Jamun Center"
    },
    { 
        id: 18, 
        name: "Shahi Rajbhog Kulfi", 
        description: "A royal wedding classic loaded with almond flakes, pistachio bits, cashew praline, pure saffron, and cardamom.", 
        category: "Premium", 
        tag: "Royal Collection",
        badgeColor: "bg-yellow-100 text-yellow-900 border-yellow-200", 
        image: "/images/products/kulfi_kesar.jpg", 
        price: 75,
        highlight: "5 Dry Fruit Blend"
    },
    { 
        id: 19, 
        name: "Chikoo (Sapota) Kulfi", 
        description: "Naturally sweet caramelized Dahanu sapota fruit pulp blended into thick, slow-churned pure milk cream.", 
        category: "Fruit", 
        tag: "Farm Fresh",
        badgeColor: "bg-amber-100 text-amber-900 border-amber-300", 
        image: "/images/products/kulfi_chocolate.jpg", 
        price: 60,
        highlight: "Dahanu Sapota Pulp"
    },
    { 
        id: 20, 
        name: "Spicy Guava (Amrud) Kulfi", 
        description: "Sweet pink Allahabad guava puree frozen and dusted with a hint of roasted red chilli rock salt.", 
        category: "Fruit", 
        tag: "Street Style",
        badgeColor: "bg-red-100 text-red-900 border-red-200", 
        image: "/images/products/kulfi_rose.jpg", 
        price: 65,
        highlight: "Pink Guava & Chilli"
    },
    { 
        id: 21, 
        name: "Kaju Draksh Kulfi", 
        description: "A Gujarati celebratory classic packed with roasted crunchy cashews and sweet plump black Afghan raisins.", 
        category: "Premium", 
        tag: "Festive Special",
        badgeColor: "bg-emerald-100 text-emerald-900 border-emerald-200", 
        image: "/images/products/kulfi_malai.jpg", 
        price: 70,
        highlight: "Toasted Cashew & Raisin"
    },
    { 
        id: 22, 
        name: "Roasted Hazelnut Cocoa Kulfi", 
        description: "Imported Italian roasted hazelnuts stone-ground into decadent dark cocoa and frozen condensed milk.", 
        category: "Indulgent", 
        tag: "Gourmet",
        badgeColor: "bg-stone-200 text-stone-900 border-stone-300", 
        image: "/images/products/kulfi_chocolate.jpg", 
        price: 80,
        highlight: "Roasted Hazelnut Crunch"
    },
    { 
        id: 23, 
        name: "Jaggery & Roasted Almond Kulfi", 
        description: "Traditional organic palm jaggery (Gud) boiled with cardamom and studded with crunchy roasted California almonds.", 
        category: "Classic", 
        tag: "No Refined Sugar",
        badgeColor: "bg-orange-100 text-orange-900 border-orange-200", 
        image: "/images/products/kulfi_kesar.jpg", 
        price: 65,
        highlight: "Organic Palm Jaggery"
    },
    { 
        id: 24, 
        name: "Lychee Blossom Kulfi", 
        description: "Sweet, juicy Muzaffarpur lychee fruit chunks folded smoothly into cold floral cream rabdi.", 
        category: "Fruit", 
        tag: "Summer Hit",
        badgeColor: "bg-pink-100 text-pink-900 border-pink-200", 
        image: "/images/products/kulfi_rose.jpg", 
        price: 65,
        highlight: "Fresh Lychee Chunks"
    },
    { 
        id: 25, 
        name: "Blueberry Crumble Kulfi", 
        description: "Tart Canadian wild blueberry coulis swirled with buttery digestive biscuit crumble into frozen cream.", 
        category: "Indulgent", 
        tag: "Modern Fusion",
        badgeColor: "bg-purple-100 text-purple-900 border-purple-200", 
        image: "/images/products/kulfi_rose.jpg", 
        price: 85,
        highlight: "Wild Blueberries & Crumble"
    },
    { 
        id: 26, 
        name: "Paan Bahar Special Kulfi", 
        description: "Authentic Meetha Paan essence with natural silver leaf (varq), cooling menthol, sweet gulkand, and dried dates.", 
        category: "Floral", 
        tag: "Digestive Treat",
        badgeColor: "bg-green-100 text-green-900 border-green-200", 
        image: "/images/products/kulfi_paan.jpg", 
        price: 75,
        highlight: "Silver Varq & Meetha Paan"
    },
    { 
        id: 27, 
        name: "Dark Belgian Brownie Kulfi", 
        description: "Chunk-filled chocolate paradise featuring gooey baked walnut brownie pieces folded into rich chocolate rabdi.", 
        category: "Indulgent", 
        tag: "Crowd Favorite",
        badgeColor: "bg-stone-200 text-stone-900 border-stone-300", 
        image: "/images/products/kulfi_chocolate.jpg", 
        price: 85,
        highlight: "Real Walnut Brownie"
    },
    { 
        id: 28, 
        name: "Butterscotch Caramel Crunch", 
        description: "Golden buttery brown sugar rabdi packed with crunchy caramelized cashew praline chunks.", 
        category: "Indulgent", 
        tag: "Crunchy Classic",
        badgeColor: "bg-yellow-100 text-yellow-900 border-yellow-200", 
        image: "/images/products/kulfi_kesar.jpg", 
        price: 65,
        highlight: "Caramelized Praline"
    },
    { 
        id: 29, 
        name: "Golden Saffron Sitaphal Kulfi", 
        description: "A luxury pairing of Kashmiri saffron strands and creamy fresh custard apple pulp.", 
        category: "Fruit", 
        tag: "Exotic Fusion",
        badgeColor: "bg-lime-100 text-lime-900 border-lime-200", 
        image: "/images/products/kulfi_pista.jpg", 
        price: 70,
        highlight: "Saffron & Sitaphal"
    },
    { 
        id: 30, 
        name: "Sugar-Free Kesar Pista Kulfi", 
        description: "Rich saffron and pistachio indulgence with zero guilt, sweetened with plant-based natural stevia.", 
        category: "Classic", 
        tag: "Diabetic Friendly",
        badgeColor: "bg-teal-100 text-teal-900 border-teal-200", 
        image: "/images/products/kulfi_pista.jpg", 
        price: 75,
        highlight: "0g Sugar • Plant Stevia"
    }
];

const categories = ["All", "Classic", "Premium", "Fruit", "Floral", "Indulgent"];

export default function Products() {
    const navigate = useNavigate();
    const [cart, setCart] = useState([]);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [sortBy, setSortBy] = useState("recommended");
    
    // Multi-step Checkout State
    const [checkoutStep, setCheckoutStep] = useState('cart'); // 'cart' | 'details'
    const [customerDetails, setCustomerDetails] = useState({ name: '', phone: '', address: '', paymentMethod: 'UPI' });
    const [isProcessing, setIsProcessing] = useState(false);
    
    const [checkoutToken, setCheckoutToken] = useState(null);
    const [completedOrder, setCompletedOrder] = useState(null);

    // Cart Helper Functions
    const addToCart = (product) => {
        setCart(prev => {
            const existing = prev.find(item => item.id === product.id);
            if (existing) {
                return prev.map(item => item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item);
            }
            return [...prev, { ...product, quantity: 1 }];
        });
    };

    const updateQuantity = (productId, delta) => {
        setCart(prev => {
            return prev.map(item => {
                if (item.id === productId) {
                    const newQty = item.quantity + delta;
                    return newQty > 0 ? { ...item, quantity: newQty } : null;
                }
                return item;
            }).filter(Boolean);
        });
    };

    const getItemQuantity = (productId) => {
        const item = cart.find(i => i.id === productId);
        return item ? item.quantity : 0;
    };

    const handleProceedToDetails = () => {
        if (localStorage.getItem('isLoggedIn') !== 'true') {
            navigate('/login', { state: { from: { pathname: '/products' } } });
            return;
        }
        setCheckoutStep('details');
    };

    const handleConfirmBooking = (e) => {
        e.preventDefault();
        setIsProcessing(true);
        
        setTimeout(() => {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let token = '';
            for (let i = 0; i < 6; i++) {
                token += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            
            const newOrder = { 
                id: `ORD-${Math.floor(10000 + Math.random() * 90000)}`,
                token: `RB-${token}`,
                date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
                total: cartTotal,
                status: 'Completed',
                method: customerDetails.paymentMethod === 'COD' ? 'Cash on Delivery' : 'UPI',
                items: cart.map(item => ({ name: item.name, quantity: item.quantity, price: item.price }))
            };
            
            const existingOrders = JSON.parse(localStorage.getItem('orderHistory') || '[]');
            localStorage.setItem('orderHistory', JSON.stringify([newOrder, ...existingOrders]));

            setCheckoutToken(`RB-${token}`);
            setCompletedOrder({ 
                ...customerDetails, 
                token: `RB-${token}`,
                total: cartTotal
            });
            
            // Reset Cart
            setCart([]);
            setCustomerDetails({ name: '', phone: '', address: '', paymentMethod: 'UPI' });
            setIsCartOpen(false);
            setIsProcessing(false);
            setTimeout(() => setCheckoutStep('cart'), 300);
        }, 3000);
    };

    const closeCart = () => {
        setIsCartOpen(false);
        setTimeout(() => setCheckoutStep('cart'), 300);
    };

    const cartTotal = cart.reduce((total, item) => total + (item.price * item.quantity), 0);
    const cartCount = cart.reduce((count, item) => count + item.quantity, 0);

    // Filter & Sort Logic
    const filteredProducts = useMemo(() => {
        return products.filter(p => {
            const matchesCategory = selectedCategory === "All" || p.category === selectedCategory;
            const matchesSearch = p.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                                  p.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                  p.highlight.toLowerCase().includes(searchQuery.toLowerCase());
            return matchesCategory && matchesSearch;
        }).sort((a, b) => {
            if (sortBy === 'price-low') return a.price - b.price;
            if (sortBy === 'price-high') return b.price - a.price;
            return a.id - b.id; // default recommended
        });
    }, [selectedCategory, searchQuery, sortBy]);

    return (
        <div className="relative min-h-screen bg-[#FAFDFB] font-sans">
            <Header />

            {/* Hero Section */}
            <section className="relative pt-[130px] sm:pt-[160px] pb-12 px-6 sm:px-12 lg:px-24 overflow-hidden border-b border-gray-100/80">
                <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#73C8BD]/15 rounded-full blur-[120px] pointer-events-none -z-10" />
                <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-amber-100/30 rounded-full blur-[100px] pointer-events-none -z-10" />
                
                <div className="max-w-5xl mx-auto text-center">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#73C8BD]/30 shadow-sm mb-6">
                        <IoIceCreamOutline className="text-[#73C8BD] text-xl" />
                        <span className="text-xs sm:text-sm font-extrabold text-[#73C8BD] tracking-wider uppercase">Authentic Recipe • 30 Flavors</span>
                    </div>

                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-tight mb-5">
                        Discover the Pure Taste of <br/>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#73C8BD] via-emerald-500 to-[#181F38]">
                            Traditional Indian Kulfi
                        </span>
                    </h1>
                    
                    <p className="text-slate-600 font-medium text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
                        Handcrafted with 100% pure slow-reduced buffalo milk, crushed nuts, and authentic fruits. Delivered ice-cold right to your door.
                    </p>

                    {/* Trust Signals & Quality Guarantees */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto pt-2">
                        <div className="bg-white/80 backdrop-blur-sm p-4 rounded-2xl border border-slate-100 shadow-sm flex items-center gap-3.5">
                            <div className="w-10 h-10 rounded-xl bg-[#EAF8F5] text-[#73C8BD] flex items-center justify-center text-xl shrink-0">
                                <HiOutlineShieldCheck />
                            </div>
                            <div className="text-left">
                                <div className="text-xs font-bold text-slate-900 uppercase tracking-wide">100% Pure Milk</div>
                                <div className="text-xs text-slate-500 font-medium">No artificial vegetable oil</div>
                            </div>
                        </div>

                        <div className="bg-white/80 backdrop-blur-sm p-4 rounded-2xl border border-slate-100 shadow-sm flex items-center gap-3.5">
                            <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-xl shrink-0">
                                <HiOutlineTruck />
                            </div>
                            <div className="text-left">
                                <div className="text-xs font-bold text-slate-900 uppercase tracking-wide">Fast Delivery</div>
                                <div className="text-xs text-slate-500 font-medium">Insulated thermal boxes</div>
                            </div>
                        </div>

                        <div className="bg-white/80 backdrop-blur-sm p-4 rounded-2xl border border-slate-100 shadow-sm flex items-center gap-3.5">
                            <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-xl shrink-0">
                                <HiOutlineClock />
                            </div>
                            <div className="text-left">
                                <div className="text-xs font-bold text-slate-900 uppercase tracking-wide">Instant Priority Token</div>
                                <div className="text-xs text-slate-500 font-medium">Fast truck pickup & track</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Product Catalog Section */}
            <main className="py-8 px-6 sm:px-12 lg:px-24 max-w-7xl mx-auto">
                
                {/* Clean Filter & Interactive Search Panel */}
                <div className="bg-white rounded-3xl p-4 sm:p-5 border border-slate-100 shadow-[0_4px_24px_rgba(0,0,0,0.04)] mb-8 flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-4">
                    
                    {/* Category Filter Chips */}
                    <div className="flex items-center gap-2 flex-wrap">
                        {categories.map((cat) => {
                            const count = cat === "All" ? products.length : products.filter(p => p.category === cat).length;
                            const isActive = selectedCategory === cat;
                            return (
                                <button
                                    key={cat}
                                    onClick={() => setSelectedCategory(cat)}
                                    className={`px-4 py-2.5 rounded-2xl text-xs sm:text-sm font-bold transition-all flex items-center gap-2 cursor-pointer ${
                                        isActive 
                                            ? 'bg-[#181F38] text-white shadow-md shadow-slate-900/15 scale-[1.02]' 
                                            : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border border-slate-100'
                                    }`}
                                >
                                    <span>{cat}</span>
                                    <span className={`text-[11px] font-extrabold px-2 py-0.5 rounded-full ${isActive ? 'bg-white/20 text-white' : 'bg-slate-200/80 text-slate-500'}`}>
                                        {count}
                                    </span>
                                </button>
                            );
                        })}
                    </div>

                    {/* Search & Sort Controls */}
                    <div className="flex items-center gap-3 w-full lg:w-auto">
                        {/* Search Input */}
                        <div className="relative flex-1 lg:w-72">
                            <IoSearchOutline className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-lg pointer-events-none" />
                            <input
                                type="text"
                                placeholder="Search flavor or ingredient..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full pl-10 pr-8 py-2.5 bg-slate-50 border border-slate-200 rounded-2xl text-xs sm:text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#73C8BD] focus:bg-white transition-all"
                            />
                            {searchQuery && (
                                <button onClick={() => setSearchQuery("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 text-sm font-bold">
                                    ✕
                                </button>
                            )}
                        </div>

                        {/* Sort Dropdown */}
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                            className="bg-slate-50 border border-slate-200 text-slate-700 text-xs sm:text-sm font-bold rounded-2xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#73C8BD] cursor-pointer"
                        >
                            <option value="recommended">Featured</option>
                            <option value="price-low">Price: Low to High</option>
                            <option value="price-high">Price: High to Low</option>
                        </select>
                    </div>
                </div>
                
                {/* Result Status Header */}
                <div className="flex items-center justify-between mb-8 pb-4 border-b border-slate-100">
                    <div className="text-slate-500 text-sm font-semibold">
                        Showing <span className="text-slate-900 font-extrabold">{filteredProducts.length}</span> of {products.length} flavors
                    </div>
                    {cartCount > 0 && (
                        <button 
                            onClick={() => setIsCartOpen(true)}
                            className="text-[#73C8BD] font-bold text-sm hover:underline flex items-center gap-1.5"
                        >
                            <HiOutlineShoppingBag />
                            View Cart ({cartCount} items • ₹{cartTotal})
                        </button>
                    )}
                </div>

                {filteredProducts.length === 0 ? (
                    <div className="bg-white rounded-3xl p-16 text-center border border-slate-100 shadow-sm max-w-lg mx-auto">
                        <IoIceCreamOutline className="text-6xl text-slate-300 mx-auto mb-4" />
                        <h3 className="text-xl font-extrabold text-slate-800 mb-2">No matching flavors found</h3>
                        <p className="text-slate-500 text-sm mb-6">We couldn't find any kulfi matching "{searchQuery}". Try searching for another ingredient or reset your filter.</p>
                        <button 
                            onClick={() => { setSelectedCategory("All"); setSearchQuery(""); }}
                            className="bg-[#181F38] text-white px-6 py-2.5 rounded-full font-bold text-sm hover:bg-slate-800 transition-colors"
                        >
                            Reset Filters
                        </button>
                    </div>
                ) : (
                    /* The 3-Column Grid */
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredProducts.map((product) => {
                            const qtyInCart = getItemQuantity(product.id);

                            return (
                                <div 
                                    key={product.id}
                                    className="group bg-white rounded-[28px] p-6 shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-slate-100/80 flex flex-col justify-between hover:shadow-[0_16px_36px_rgba(0,0,0,0.08)] hover:-translate-y-1.5 transition-all duration-300 relative overflow-hidden"
                                >
                                    {/* Top Metadata Badges */}
                                    <div className="flex items-center justify-between gap-2 mb-4 relative z-10">
                                        <span className={`px-3 py-1 rounded-full text-[11px] font-extrabold uppercase tracking-wider border ${product.badgeColor}`}>
                                            {product.tag}
                                        </span>
                                        <span className="text-[11px] font-bold text-slate-400 uppercase tracking-wider bg-slate-50 px-2.5 py-1 rounded-full border border-slate-100">
                                            {product.category}
                                        </span>
                                    </div>

                                    {/* Product Visual Container */}
                                    <div className="w-full h-56 rounded-2xl bg-gradient-to-br from-slate-50 to-slate-100/50 mb-5 flex items-center justify-center p-4 relative overflow-hidden group-hover:from-[#EAF8F5]/40 group-hover:to-white transition-colors duration-300">
                                        <div className="absolute w-40 h-40 bg-[#73C8BD]/10 rounded-full blur-2xl pointer-events-none group-hover:scale-150 transition-transform duration-500" />
                                        <img 
                                            src={product.image} 
                                            alt={product.name} 
                                            loading="lazy"
                                            className="h-full w-auto object-contain mix-blend-multiply drop-shadow-md group-hover:scale-110 transition-transform duration-500 relative z-10" 
                                            style={{ filter: 'brightness(1.12) contrast(1.12)' }}
                                        />
                                    </div>

                                    {/* Content & Details */}
                                    <div className="mb-5 flex-1 flex flex-col">
                                        <div className="flex items-start justify-between gap-2 mb-2">
                                            <h3 className="text-xl font-black text-slate-900 group-hover:text-[#73C8BD] transition-colors leading-snug">
                                                {product.name}
                                            </h3>
                                        </div>
                                        
                                        <p className="text-slate-500 text-xs sm:text-sm leading-relaxed mb-4 flex-1 line-clamp-3">
                                            {product.description}
                                        </p>

                                        {/* Highlight Ingredient Pill */}
                                        <div className="inline-flex items-center gap-1.5 text-[11px] font-bold text-[#73C8BD] bg-[#EAF8F5] px-3 py-1 rounded-lg w-fit">
                                            <IoSparklesOutline />
                                            <span>{product.highlight}</span>
                                        </div>
                                    </div>

                                    {/* Bottom Price & Action Footer */}
                                    <div className="border-t border-slate-100 pt-4 flex items-center justify-between gap-3">
                                        <div>
                                            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block">Price</span>
                                            <span className="text-2xl font-black text-slate-900">₹{product.price}</span>
                                        </div>

                                        {/* Inline Quantity Controls if in Cart, else Add Button */}
                                        {qtyInCart > 0 ? (
                                            <div className="flex items-center gap-2 bg-[#181F38] text-white rounded-xl p-1 shadow-md">
                                                <button
                                                    onClick={() => updateQuantity(product.id, -1)}
                                                    className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 flex items-center justify-center text-white transition-colors"
                                                    aria-label="Decrease quantity"
                                                >
                                                    {qtyInCart === 1 ? <HiTrash className="text-sm text-red-400" /> : <HiMinus className="text-sm" />}
                                                </button>
                                                
                                                <span className="w-6 text-center font-black text-sm text-white">
                                                    {qtyInCart}
                                                </span>
                                                
                                                <button
                                                    onClick={() => updateQuantity(product.id, 1)}
                                                    className="w-8 h-8 rounded-lg bg-[#73C8BD] hover:bg-emerald-400 flex items-center justify-center text-white transition-colors"
                                                    aria-label="Increase quantity"
                                                >
                                                    <HiPlus className="text-sm" />
                                                </button>
                                            </div>
                                        ) : (
                                            <button 
                                                onClick={() => addToCart(product)}
                                                className="bg-[#73C8BD] hover:bg-[#5ebcae] text-white font-bold text-xs sm:text-sm px-5 py-3 rounded-xl transition-all shadow-[0_4px_14px_rgba(115,200,189,0.4)] hover:shadow-[0_6px_20px_rgba(115,200,189,0.5)] active:scale-95 flex items-center gap-2"
                                            >
                                                <HiOutlineShoppingBag className="text-base" />
                                                <span>Add to Cart</span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </main>

            {/* Franchise Partnership Banner (White Theme & Human-Crafted Real Copy) */}
            <section className="py-12 px-6 sm:px-12 lg:px-24 max-w-7xl mx-auto my-8">
                <div className="relative bg-gradient-to-br from-white via-[#F4FBF9] to-[#FFF9F2] rounded-[36px] p-8 sm:p-12 lg:p-16 border border-emerald-100/80 shadow-[0_20px_50px_rgba(115,200,189,0.12)] overflow-hidden flex flex-col lg:flex-row items-center justify-between gap-12">
                    
                    {/* Background Decorative Glows */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-[#73C8BD]/20 rounded-full blur-[100px] pointer-events-none translate-x-1/3 -translate-y-1/3" />
                    <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-200/25 rounded-full blur-[90px] pointer-events-none -translate-x-1/3 translate-y-1/3" />
                    
                    {/* Left Info Column */}
                    <div className="relative z-10 max-w-2xl text-left">
                        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#EAF8F5] border border-[#73C8BD]/30 mb-6 shadow-sm">
                            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                            <span className="text-xs font-black text-[#181F38] uppercase tracking-wider">Zero Royalty • High Margin Business</span>
                        </div>

                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-4">
                            Bring Rainbow Trucks to Your City. <br className="hidden sm:inline" />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#73C8BD] to-emerald-600">
                                Launch Your Kulfi Business Today.
                            </span>
                        </h2>
                        
                        <p className="text-base sm:text-lg text-slate-600 font-medium leading-relaxed mb-8 max-w-xl">
                            Join South India's fastest-growing dessert network. We provide fully equipped carts, direct factory stock delivery, location guidance, and full training—so you start generating profit from Day 1.
                        </p>

                        {/* 3 Real Metric Pillars */}
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3.5 mb-8">
                            <div className="bg-white/90 backdrop-blur-sm p-4 rounded-2xl border border-slate-100 shadow-sm">
                                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Starting Investment</div>
                                <div className="text-lg font-black text-slate-900">₹2.5 Lakhs+</div>
                                <div className="text-[11px] text-slate-500 font-medium mt-0.5">Turnkey cart setup</div>
                            </div>
                            <div className="bg-white/90 backdrop-blur-sm p-4 rounded-2xl border border-slate-100 shadow-sm">
                                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Expected Payback</div>
                                <div className="text-lg font-black text-emerald-600">3 to 6 Months</div>
                                <div className="text-[11px] text-slate-500 font-medium mt-0.5">Fast capital recovery</div>
                            </div>
                            <div className="bg-white/90 backdrop-blur-sm p-4 rounded-2xl border border-slate-100 shadow-sm">
                                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Profit Retention</div>
                                <div className="text-lg font-black text-slate-900">100% Yours</div>
                                <div className="text-[11px] text-slate-500 font-medium mt-0.5">0% ongoing royalties</div>
                            </div>
                        </div>

                        {/* Action Link */}
                        <div className="flex flex-wrap items-center gap-4">
                            <a 
                                href="/#franchise-options" 
                                className="inline-flex h-14 items-center justify-center px-8 bg-[#181F38] hover:bg-slate-800 text-white font-bold rounded-full transition-all shadow-[0_8px_24px_rgba(24,31,56,0.25)] hover:shadow-[0_12px_32px_rgba(24,31,56,0.35)] hover:-translate-y-1 gap-3 group"
                            >
                                <span>Explore Franchise Packages</span>
                                <span className="text-[#73C8BD] group-hover:translate-x-1.5 transition-transform text-xl">→</span>
                            </a>
                            <span className="text-xs font-semibold text-slate-500">
                                ⚡ Limited territorial slots available
                            </span>
                        </div>
                    </div>

                    {/* Right Visual Feature Card */}
                    <div className="relative z-10 w-full max-w-sm">
                        <div className="bg-white/95 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-slate-100 shadow-[0_12px_36px_rgba(0,0,0,0.06)] relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-24 h-24 bg-[#73C8BD]/10 rounded-full blur-xl" />
                            
                            <div className="flex items-center gap-3.5 mb-6 pb-4 border-b border-slate-100">
                                <div className="w-12 h-12 rounded-2xl bg-[#EAF8F5] text-[#73C8BD] flex items-center justify-center text-2xl font-bold shadow-sm">
                                    🍦
                                </div>
                                <div>
                                    <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">Turnkey Business</div>
                                    <div className="text-lg font-black text-slate-900">Partner Benefits</div>
                                </div>
                            </div>

                            <ul className="space-y-3.5 mb-6 text-sm font-semibold text-slate-700">
                                <li className="flex items-start gap-2.5">
                                    <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">✓</span>
                                    <span><strong>50%–60% Gross Margin</strong> on all 15 authentic flavors</span>
                                </li>
                                <li className="flex items-start gap-2.5">
                                    <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">✓</span>
                                    <span><strong>Cold-Chain Direct Supply</strong> shipped straight from central kitchen</span>
                                </li>
                                <li className="flex items-start gap-2.5">
                                    <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">✓</span>
                                    <span><strong>Ready-to-Roll Mobile Setup</strong> with customized refrigeration</span>
                                </li>
                                <li className="flex items-start gap-2.5">
                                    <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">✓</span>
                                    <span><strong>Site Selection & Staff Guidance</strong> by operations team</span>
                                </li>
                            </ul>

                            <div className="bg-[#EAF8F5] rounded-2xl p-4 text-center border border-[#73C8BD]/20">
                                <div className="text-xs font-extrabold text-[#73C8BD] uppercase tracking-wider flex items-center justify-center gap-1.5">
                                    <span className="w-2 h-2 rounded-full bg-[#73C8BD] animate-ping" />
                                    <span>Territory Registrations Open</span>
                                </div>
                                <div className="text-sm font-black text-slate-800 mt-1">Chennai • Coimbatore • Madurai • Bangalore</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            {/* Floating Shopping Cart Trigger Button */}
            <button 
                onClick={() => setIsCartOpen(true)}
                className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-[#181F38] text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all hover:bg-slate-800 group"
                aria-label="Open Cart"
            >
                <HiOutlineShoppingBag className="text-2xl text-[#73C8BD] group-hover:scale-110 transition-transform" />
                {cartCount > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 w-7 h-7 bg-[#FA8CA6] text-white text-xs font-black rounded-full flex items-center justify-center border-2 border-white shadow-md animate-bounce">
                        {cartCount}
                    </span>
                )}
            </button>

            {/* Slide-over Cart Drawer */}
            <div className={`fixed inset-0 z-[100] transition-opacity duration-300 ${isCartOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
                {/* Backdrop */}
                <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity" onClick={closeCart} />
                
                {/* Drawer Container */}
                <div className={`absolute top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl transition-transform duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] flex flex-col ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                    
                    {/* Drawer Header */}
                    <div className="flex items-center justify-between p-6 border-b border-slate-100">
                        <div className="flex items-center gap-3">
                            {checkoutStep === 'details' && (
                                <button onClick={() => setCheckoutStep('cart')} className="text-slate-400 hover:text-slate-900 transition-colors bg-slate-50 w-8 h-8 rounded-full flex items-center justify-center">
                                    <span className="text-lg leading-none">&larr;</span>
                                </button>
                            )}
                            <h2 className="text-2xl font-black text-slate-900">
                                {checkoutStep === 'cart' ? 'Your Cart' : 'Delivery Details'}
                            </h2>
                        </div>
                        <button onClick={closeCart} className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 hover:bg-slate-200 transition-colors">
                            <IoClose className="text-xl" />
                        </button>
                    </div>

                    {/* Scrollable Cart Content */}
                    <div className="flex-1 overflow-y-auto p-6">
                        {checkoutStep === 'cart' ? (
                            cart.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-full text-center">
                                    <HiOutlineShoppingBag className="text-6xl text-slate-200 mb-4" />
                                    <p className="text-slate-700 text-lg font-bold">Your cart is empty.</p>
                                    <p className="text-slate-400 text-sm mt-1">Add some delicious kulfis to book.</p>
                                </div>
                            ) : (
                                <div className="flex flex-col gap-4">
                                    {cart.map(item => (
                                        <div key={item.id} className="flex items-center justify-between border border-slate-100 rounded-2xl p-4 bg-slate-50">
                                            <div className="flex items-center gap-3.5">
                                                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-sm overflow-hidden p-1 border border-slate-100">
                                                    <img src={item.image} alt={item.name} className="w-full h-full object-contain mix-blend-multiply" />
                                                </div>
                                                <div>
                                                    <h4 className="font-bold text-slate-900 text-sm">{item.name}</h4>
                                                    <div className="text-[#73C8BD] font-extrabold text-sm mt-0.5">₹{item.price}</div>
                                                </div>
                                            </div>
                                            
                                            {/* Quantity Counter */}
                                            <div className="flex items-center gap-2 bg-white px-2 py-1 rounded-xl border border-slate-200 shadow-sm">
                                                <button 
                                                    onClick={() => updateQuantity(item.id, -1)}
                                                    className="w-6 h-6 rounded-md hover:bg-slate-100 flex items-center justify-center text-slate-600 font-bold text-xs"
                                                >
                                                    {item.quantity === 1 ? <HiTrash className="text-red-400 text-xs" /> : "-"}
                                                </button>
                                                <span className="text-xs font-black w-4 text-center text-slate-900">{item.quantity}</span>
                                                <button 
                                                    onClick={() => updateQuantity(item.id, 1)}
                                                    className="w-6 h-6 rounded-md hover:bg-slate-100 flex items-center justify-center text-slate-600 font-bold text-xs"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )
                        ) : (
                            /* Checkout Form */
                            <form id="checkout-form" onSubmit={handleConfirmBooking} className="flex flex-col gap-4">
                                <div>
                                    <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5">Full Name</label>
                                    <input 
                                        type="text" 
                                        required
                                        placeholder="e.g. Ramesh Kumar"
                                        value={customerDetails.name}
                                        onChange={(e) => setCustomerDetails({...customerDetails, name: e.target.value})}
                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-slate-900 font-medium focus:outline-none focus:ring-2 focus:ring-[#73C8BD]"
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5">Phone Number</label>
                                    <input 
                                        type="tel" 
                                        required
                                        placeholder="e.g. 9876543210"
                                        value={customerDetails.phone}
                                        onChange={(e) => setCustomerDetails({...customerDetails, phone: e.target.value})}
                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-slate-900 font-medium focus:outline-none focus:ring-2 focus:ring-[#73C8BD]"
                                    />
                                    <span className="text-[11px] text-slate-400 mt-1 block">We'll send your priority tracking token via SMS.</span>
                                </div>

                                <div>
                                    <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5">Delivery Address</label>
                                    <textarea 
                                        required
                                        rows="2"
                                        placeholder="Flat/House No., Street, Landmark, Area"
                                        value={customerDetails.address}
                                        onChange={(e) => setCustomerDetails({...customerDetails, address: e.target.value})}
                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-slate-900 font-medium focus:outline-none focus:ring-2 focus:ring-[#73C8BD] resize-none"
                                    />
                                </div>

                                <div className="mt-2">
                                    <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 mb-2">Payment Method</label>
                                    <div className="flex flex-col gap-2">
                                        <label 
                                            className={`flex items-center justify-between p-3.5 rounded-xl border-2 cursor-pointer transition-all ${customerDetails.paymentMethod === 'UPI' ? 'border-[#73C8BD] bg-[#EAF8F5]' : 'border-slate-100 bg-white hover:border-slate-200'}`}
                                            onClick={() => setCustomerDetails({...customerDetails, paymentMethod: 'UPI'})}
                                        >
                                            <div className="flex items-center gap-3">
                                                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${customerDetails.paymentMethod === 'UPI' ? 'border-[#73C8BD]' : 'border-slate-300'}`}>
                                                    {customerDetails.paymentMethod === 'UPI' && <div className="w-2.5 h-2.5 bg-[#73C8BD] rounded-full" />}
                                                </div>
                                                <span className="font-bold text-slate-900 text-sm">UPI (GPay, PhonePe, Paytm)</span>
                                            </div>
                                            <span className="text-[10px] font-bold bg-[#73C8BD] text-white px-2 py-0.5 rounded-md uppercase tracking-wider">Recommended</span>
                                        </label>

                                        <label 
                                            className={`flex items-center justify-between p-3.5 rounded-xl border-2 transition-all ${cartTotal > 200 ? 'cursor-pointer' : 'cursor-not-allowed opacity-60'} ${customerDetails.paymentMethod === 'COD' ? 'border-[#73C8BD] bg-[#EAF8F5]' : 'border-slate-100 bg-white hover:border-slate-200'}`}
                                            onClick={() => {
                                                if (cartTotal > 200) {
                                                    setCustomerDetails({...customerDetails, paymentMethod: 'COD'});
                                                }
                                            }}
                                        >
                                            <div className="flex items-center gap-3">
                                                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${customerDetails.paymentMethod === 'COD' ? 'border-[#73C8BD]' : 'border-slate-300'}`}>
                                                    {customerDetails.paymentMethod === 'COD' && <div className="w-2.5 h-2.5 bg-[#73C8BD] rounded-full" />}
                                                </div>
                                                <span className="font-bold text-slate-900 text-sm">Cash on Delivery</span>
                                            </div>
                                            {cartTotal <= 200 && (
                                                <span className="text-[10px] font-bold bg-slate-200 text-slate-500 px-2 py-0.5 rounded-md uppercase tracking-wider">Min ₹200</span>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>

                    {/* Bottom Action Footer */}
                    {cart.length > 0 && (
                        <div className="p-6 border-t border-slate-100 bg-slate-50">
                            <div className="flex items-center justify-between mb-4">
                                <span className="text-slate-500 font-semibold text-sm">Subtotal</span>
                                <span className="text-2xl font-black text-slate-900">₹{cartTotal}</span>
                            </div>
                            
                            {checkoutStep === 'cart' ? (
                                <div className="flex flex-col gap-2">
                                    <button 
                                        onClick={handleProceedToDetails}
                                        disabled={cartCount < 5}
                                        className={`w-full text-white font-bold py-4 rounded-xl transition-all shadow-lg flex items-center justify-center gap-2 ${cartCount >= 5 ? 'bg-[#181F38] hover:bg-slate-800 cursor-pointer' : 'bg-slate-300 cursor-not-allowed opacity-80'}`}
                                    >
                                        Proceed to Checkout
                                    </button>
                                    {cartCount < 5 && (
                                        <p className="text-xs text-center text-[#FA8CA6] font-bold">
                                            Minimum 5 kulfis required to book (add {5 - cartCount} more)
                                        </p>
                                    )}
                                </div>
                            ) : (
                                <button 
                                    type="submit"
                                    form="checkout-form"
                                    disabled={isProcessing}
                                    className={`w-full bg-[#73C8BD] text-white font-bold py-4 rounded-xl transition-colors shadow-lg flex items-center justify-center gap-2 ${isProcessing ? 'opacity-80 cursor-wait' : 'hover:bg-emerald-500 cursor-pointer'}`}
                                >
                                    {isProcessing ? (
                                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                    ) : (
                                        "Order Now"
                                    )}
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Order Confirmation Digital Ticket Modal */}
            {checkoutToken && completedOrder && (
                <div className="fixed inset-0 z-[110] bg-slate-900/60 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
                    <div className="bg-white rounded-[32px] p-6 sm:p-8 max-w-sm w-full text-center relative overflow-hidden shadow-2xl border border-slate-100">
                        <button onClick={() => setCheckoutToken(null)} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 hover:bg-slate-200 transition-colors">
                            <IoClose className="text-lg" />
                        </button>
                        
                        <div className="w-16 h-16 bg-[#EAF8F5] text-[#73C8BD] rounded-full flex items-center justify-center mx-auto mb-4 text-3xl shadow-inner">
                            <IoCheckmarkCircle />
                        </div>
                        
                        <h2 className="text-2xl font-black text-slate-900 mb-2">Order Confirmed!</h2>
                        <p className="text-slate-500 text-xs sm:text-sm mb-6">Hey {completedOrder.name.split(' ')[0]}, your kulfis are on the way! Please present this digital ticket to our delivery executive upon arrival.</p>
                        
                        <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100 relative overflow-hidden text-left mb-6">
                            <div className="absolute top-0 right-0 w-24 h-24 bg-[#73C8BD] opacity-10 rounded-full blur-xl translate-x-1/2 -translate-y-1/2 pointer-events-none" />
                            
                            <div className="flex items-end justify-between border-b border-dashed border-slate-200 pb-3 mb-3">
                                <div>
                                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5 block">Priority Token</span>
                                    <div className="text-2xl font-black text-[#181F38] tracking-wider">{checkoutToken}</div>
                                </div>
                                <div className="text-right">
                                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5 block">Amount</span>
                                    <div className="text-lg font-black text-[#73C8BD]">₹{completedOrder.total}</div>
                                </div>
                            </div>
                            
                            <div className="flex items-center justify-between text-xs font-medium text-slate-500 mb-3">
                                <span>Payment Method:</span>
                                <span className="font-bold text-slate-900">{completedOrder.paymentMethod === 'UPI' ? 'UPI (Pending)' : 'Cash on Delivery'}</span>
                            </div>

                            {/* Fake Barcode */}
                            <div className="w-full h-10 bg-slate-200 rounded flex items-center justify-center overflow-hidden relative opacity-70">
                                <div className="absolute inset-0 flex gap-[2px] p-2">
                                    {[...Array(28)].map((_, i) => (
                                        <div key={i} className="h-full bg-slate-800 rounded-sm" style={{ width: `${Math.random() * 4 + 1}px` }} />
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <button onClick={() => setCheckoutToken(null)} className="w-full bg-[#181F38] text-white font-bold py-3.5 rounded-xl hover:bg-slate-800 transition-colors shadow-md">
                            Done
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
